import { Route, Switch } from 'react-router-dom';

import { CheckoutStep, SuccessStep } from './Checkout/helpers';
import { useEvent } from './Common/EventProvider';
import BuyRegistrationPage from './Resale/BuyRegistrationPage';
import CheckoutPage from './Checkout/CheckoutPage';
import CheckoutProvider from './Checkout/CheckoutProvider';
import CheckoutSummaryProvider from './Checkout/CheckoutSummaryProvider';
import ErrorBoundary from './Checkout/ErrorBoundary';
import InterestPage from './Checkout/InterestPage';
import OverviewPage from './Resale/OverviewPage';
import SuccessPage from './Checkout/Success/SuccessPage';
import WaitlistPage from './Checkout/WaitlistPage';

interface MainProps {
  step?: CheckoutStep | typeof SuccessStep | null;
}

const Main = ({ step }: MainProps) => {
  const { event } = useEvent();

  return (
    <ErrorBoundary redirect={event.checkout_url}>
      <Switch>
        <Route
          path="/:eventId/waitlist/:ticketId"
          render={({ match: { params: { ticketId } } }) => (
            <WaitlistPage ticketId={ticketId} />
          )}
        />
        <Route path="/:eventId/interest">
          <InterestPage />
        </Route>
        <Route path="/:eventId/thank-you">
          <SuccessPage />
        </Route>
        <Route
          path="/:eventId/resale/:registrationId/:resaleToken"
          render={({ match: { params: { registrationId, resaleToken } } }) => (
            <BuyRegistrationPage
              registrationId={registrationId}
              resaleToken={resaleToken}
            />
          )}
        />
        <Route path="/:eventId/resale">
          <OverviewPage />
        </Route>
        <Route>
          <CheckoutSummaryProvider>
            <CheckoutProvider
              step={step}
              render={(props) => (
                <CheckoutPage {...props} />
              )}
            />
          </CheckoutSummaryProvider>
        </Route>
      </Switch>
    </ErrorBoundary>
  );
};

export default Main;
